import Loadable from "react-loadable"
import Loading from "../components/SplashScreen"

export const Home = Loadable({
	loader: () => import("../containers/Home"),
	loading: Loading,
	timeout: 2000
})

export const CallBack = Loadable({
	loader: () => import("../containers/Callback/Callback"),
	loading: Loading,
	timeout: 2000
})

export const Features = Loadable({
	loader: () => import("../containers/Features"),
	loading: Loading,
	timeout: 2000
})

export const Services = Loadable({
	loader: () => import("../containers/Services"),
	loading: Loading,
	timeout: 2000
})

export const Community = Loadable({
	loader: () => import("../containers/Community"),
	loading: Loading,
	timeout: 2000
})

export const GlobalProjects = Loadable({
	loader: () => import("../containers/GlobalProjects"),
	loading: Loading,
	timeout: 2000
})

export const MyProjects = Loadable({
	loader: () => import("../containers/MyProjects"),
	loading: Loading,
	timeout: 2000
})

export const UserProfile = Loadable({
	loader: () => import("../containers/UserProfile"),
	loading: Loading,
	timeout: 2000
})

export const EditYourProfile = Loadable({
	loader: () => import("../containers/EditYourProfile"),
	loading: Loading,
	timeout: 2000
})

export const ProjectOverview = Loadable({
	loader: () => import("../containers/ProjectOverview"),
	loading: Loading,
	timeout: 2000
})

export const ProjectOverviews = Loadable({
	loader: () => import("../containers/ProjectOverviews"),
	loading: Loading,
	timeout: 2000
})

export const CreateProject = Loadable({
	loader: () => import("../containers/CreateProject"),
	loading: Loading,
	timeout: 2000
})

export const ModelOverview = Loadable({
	loader: () => import("../containers/ModelOverview"),
	loading: Loading,
	timeout: 2000
})

export const CreateModel = Loadable({
	loader: () => import("../containers/CreateModel"),
	loading: Loading,
	timeout: 2000
})

export const AddScript = Loadable({
	loader: () => import("../containers/AddScript"),
	loading: Loading,
	timeout: 2000
})

export const TermsPrivacypolicy = Loadable({
	loader: () => import("../containers/TermsPrivacypolicy"),
	loading: Loading,
	timeout: 2000
})

export const Tutorial = Loadable({
	loader: () => import("../containers/Tutorial"),
	loading: Loading,
	timeout: 2000
})
export const VideoDetail = Loadable({
	loader: () => import("../containers/VideoDetail"),
	loading: Loading,
	timeout: 2000
})
export const Document = Loadable({
	loader: () => import("../containers/Document"),
	loading: Loading,
	timeout: 2000
})

export const Notfound = Loadable({
	loader: () => import("../components/Notfound"),
	loading: Loading,
	timeout: 2000
})

export const AdvancedSearch = Loadable({
	loader: () => import("../containers/AdvancedSearch"),
	loading: Loading,
	timeout: 2000
})
export const ThankyouSignup = Loadable({
	loader: () => import("../containers/ThankyouSignup"),
	loading: Loading,
	timeout: 2000
})
/////////////////////Mobile/////////////////////////

export const MLogin = Loadable({
	loader: () => import("../containers/Mobile/Login"),
	loading: Loading,
	timeout: 2000
})

export const MContactus = Loadable({
	loader: () => import("../containers/Mobile/Contactus"),
	loading: Loading,
	timeout: 2000
})

export const MRegister = Loadable({
	loader: () => import("../containers/Mobile/Register"),
	loading: Loading,
	timeout: 2000
})

export const MForgotPassword = Loadable({
	loader: () => import("../containers/Mobile/ForgotPassword"),
	loading: Loading,
	timeout: 2000
})

export const MConfirmRegistration = Loadable({
	loader: () => import("../containers/Mobile/ConfirmRegistration"),
	loading: Loading,
	timeout: 2000
})

export const MRestorepassword = Loadable({
	loader: () => import("../containers/Mobile/Restorepassword"),
	loading: Loading,
	timeout: 2000
})

export const MRepassword = Loadable({
	loader: () => import("../containers/Mobile/Repassword"),
	loading: Loading,
	timeout: 2000
})

export const MRestorename = Loadable({
	loader: () => import("../containers/Mobile/Restorename"),
	loading: Loading,
	timeout: 2000
})
